import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import generaleReducer from "./slices/generale";
import agentReducer from "./slices/agent";
import supervisorReducer from "./slices/supervisor";
import limittransactionReducer from "./slices/limittransaction";
import ticketReducer from "./slices/ticket";
import reportReducer from "./slices/report";

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const productPersistConfig = {
  key: "product",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

const rootReducer = combineReducers({
  ticket: ticketReducer,
  report: reportReducer,
  generale: generaleReducer,
  supervisor: supervisorReducer,
  agent: agentReducer,
  limit_transaction: limittransactionReducer,
});

export { rootPersistConfig, rootReducer };
